import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * `lazy` é obrigatório aqui, não estilístico: o `maplibre-gl` pesa mais que
 * todo o resto do bundle somado. Importá-lo estaticamente estouraria o
 * orçamento de 200 KB gzip da rota raiz (docs/07-mobile-e-pwa.md §13) para
 * todo usuário — inclusive quem nunca abre o mapa.
 */
const MapPage = lazy(() => import('./routes/Map.page'));
const OperationMapPage = lazy(() => import('./routes/OperationMap.page'));

/**
 * O mapa é a **rota índice**, não `/map`: as regras definem a Home como a tela
 * de mapa (docs/regras-de-negocio/12 §3), e é para onde login, cadastro e
 * entrada como convidado levam (02 §4 e RN-01). Um redirect de `/` para `/map`
 * seria um salto visível na abertura, em todo acesso.
 */
export const mapRoutes: RouteObject[] = [{ index: true, element: <MapPage /> }];

/**
 * Mapa da operação de uma instituição — fluxo de trabalho, **fora** do
 * `AppLayout` (sem barra inferior) e sob `RequireSession`, como a gestão da
 * instituição e a tela de chamados.
 *
 * O caminho fica sob `institutions/:id` porque a operação é **daquela**
 * instituição; o **módulo** que serve a tela é este, que é quem tem o canvas do
 * mapa. É o que permite a gestão apontar para cá por URL sem que `institutions`
 * importe UI daqui (docs/01, opção 1) — o mesmo arranjo de
 * `/institutions/:id/calls`.
 *
 * `operation`, e não `map`: `/institutions/:id/map` soaria como "o ponto dela no
 * mapa", que é outra coisa (e já existe, pelo `?lat=&lng=` da home).
 */
export const mapProtectedRoutes: RouteObject[] = [
  { path: 'institutions/:id/operation', element: <OperationMapPage /> },
];
